export default function Loading() {
    return <p><i>Loading...</i></p>;
}